import { Injectable, Inject, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/internal/operators/catchError';
import { throwError } from 'rxjs/internal/observable/throwError';
import { HeadServiceService } from 'src/app/shared/services/head-service.service';
import { Observable } from 'rxjs/internal/Observable';
import { CSS } from './css';
import { isNullOrUndefined } from 'src/app/helpers/tools';
import { TokenContent } from 'src/app/layouts/public/login//models/tokenContent';
import cssVariables from './cssVariables.json'
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { StringObject } from "src/app/shared/models/stringObject";
import {ObjectHolder} from "../../models/objectHolder";

@Injectable({
    providedIn: 'root'
})
export class StyleService {

    constructor(@Inject('BASE_URL') private baseUrl: string, private _http: HttpClient, private _headService: HeadServiceService) {
        this.myAppUrl = baseUrl;
    }

    myAppUrl = '';
    private _styleElement: HTMLStyleElement;
    private _appliedStyle: any;
    public oldCSS: string = "";
    private _isCustom: boolean = false;

    public async getUsersStyles() {
        let result = await firstValueFrom(this._getUsersStyles());
        if (result) {
            await this.buildStylesheet(result.item1);
            this._appliedStyle = result.item2;
            this._headService.updateTitle(this.portalTitle);
        }
    }

    public async buildStylesheet(cssList) {
        // remove style element
        if (this._styleElement && this._styleElement.parentElement != null) {
            document.getElementsByTagName("head")[0].removeChild(this._styleElement);
        }

        if (cssList && cssList.length >= 1) {
            let newCSS = ":root {";
            for (let i = 0; i < cssList.length; i++) {
                newCSS += cssList[i].name + ": " + cssList[i].value + "; ";
                if (cssList[i].name == "--navigation-text-color" && cssList[i].value.includes("black")) {
                    if (document.body.classList.contains("text-color-light")) {
                        document.body.classList.remove("text-color-light");
                    }
                    if (!document.body.classList.contains("text-color-dark")) {
                        document.body.classList.add("text-color-dark");
                    }
                } else if (cssList[i].name == "--navigation-text-color" && cssList[i].value.includes("white")) {
                    if (document.body.classList.contains("text-color-dark")) {
                        document.body.classList.remove("text-color-dark");
                    }
                    if (!document.body.classList.contains("text-color-light")) {
                        document.body.classList.add("text-color-light");
                    }
                }
            }
            newCSS += "}";
            if (this.oldCSS != newCSS) {
                this.oldCSS = newCSS;
                if (!this._styleElement) {
                    this._styleElement = document.createElement("style");
                    this._styleElement.id = "stylesheet";
                }
                this._styleElement.innerHTML = newCSS;
            }

            // re-add style element            
            document.getElementsByTagName("head")[0].appendChild(this._styleElement);

            if (!document.body.classList.contains("custom-design")) {
                document.body.classList.add("custom-design");
            }
            this._isCustom = true;
        } else {
            if (this._styleElement) {
                this._styleElement.remove();
                this.oldCSS = null;
            }

            if (document.body.classList.contains("text-color-dark")) {
                document.body.classList.remove("text-color-dark");
            }

            if (document.body.classList.contains("text-color-light")) {
                document.body.classList.remove("text-color-light");
            }

            if (document.body.classList.contains("custom-design")) {
                document.body.classList.remove("custom-design");
            }
            this._isCustom = false;
        }
    }

    public get isCustom() {
        return this._isCustom;
    }

    private _getUsersStyles() {
        return this._http.get<any>(this.baseUrl + "api/WhiteLabel/GetUsersStyles")
            .pipe(
                catchError(this.handleError)
            );
    }

    public get portalTitle() {
        if ((this._appliedStyle && this._appliedStyle.isProductStyle)) {
            return this._appliedStyle.name;
        } else {
            return "RATA";
        }
    }
    
    public get currentStyleID() {
        return this._appliedStyle ? this._appliedStyle.styleID : null;
    }

    public getCSSVariables(styleID): Observable<CSS[]> {
        return this._http
            .get<CSS[]>(this.baseUrl + "api/WhiteLabel/GetCSSVariables?styleId=" + styleID)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getDefaultCSSVariables(): Observable<CSS[]> {
        return this._http
            .get<CSS[]>(this.baseUrl + "api/WhiteLabel/GetDefaultCSSVariables")
            .pipe(
                catchError(this.handleError)
            );
    }

    public submitStyle(styleId: number, styleName: string, cssList: CSS[]): Observable<number> {
        return this._http
           .post<number>(this.baseUrl + "api/WhiteLabel/AddOrUpdateStyle?styleId=" + styleId + '&styleName=' + encodeURIComponent(styleName), cssList)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getStyleName(styleID: number) {
        return this._http
            .get<any>(this.baseUrl + "api/WhiteLabel/GetStyleName?styleID=" + styleID)
            .pipe(
                catchError(this.handleError)
            );
    }

    public submitDefault(styleID: number) {
        return this._http
            .get<any>(this.baseUrl + "api/WhiteLabel/SubmitDefault?styleID=" + styleID)
            .pipe(
                catchError(this.handleError)
            );
    }

    public doesStyleNameExist(styleId: number, styleName: string) {
        return this._http
            .get<boolean>(this.baseUrl + "api/WhiteLabel/DoesStyleNameExist?styleId=" + styleId + "&styleName=" + styleName)
            .pipe(
                catchError(this.handleError)
            );
    }

    public generateCSSVariableTable(): Observable<void> {
        return this._http
            .post<void>(this.baseUrl + "api/WhiteLabel/AddOrUpdateCSSVariables", cssVariables)
            .pipe(
                catchError(this.handleError)
            );
    }

    public toDataUrl(url: string) {
        return this._http
            .post<StringObject>(this.baseUrl + "api/WhiteLabel/ImageToDataUrl", new ObjectHolder(url))
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }
}
